import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '@reducers/index';
import { fetchTranslatorData } from '@reducers/keyword/thunk/translatorThunk';

const CountryCodeListTwoDigit = [
  { text: 'Korean', value: 'ko' },
  { text: 'English(USA)', values: 'en' },
  { text: 'Chinese (Simplified)', value: 'zh' },
  { text: 'German', value: 'de' },
  { text: 'French', value: 'fr' },
  { text: 'Russian', value: 'ru' },
  { text: 'Portuguese', value: 'pt' },
  { text: 'Turkish', value: 'tr' },
  { text: 'Swedish', value: 'sv' },
  { text: 'Norwegian', value: 'no' },
  { text: 'Danish', value: 'da' },
  { text: 'Italian', value: 'it' },
  { text: 'Japanese', value: 'ja' },
  { text: 'Dutch', value: 'nl' },
];

const SearchBox = () => {
  const dispatch = useDispatch<AppDispatch>();

  const [text, setText] = useState('');
  const [selectedCountry, setSelectedCountry] = useState(CountryCodeListTwoDigit[0]);

  const onChangeText = useCallback((event) => {
    const { value } = event.target;
    setText(value);
  }, []);

  const onChangeSelect = useCallback((event) => {
    const { name, value } = event.target;
    setSelectedCountry(value);
  }, []);

  const onClickTranslator = useCallback(() => {
    if (text.trim().length === 0) {
      alert('You have to write Keyword first');
    } else {
      dispatch(
        fetchTranslatorData({
          userId: 'SS',
          text: text,
        })
      );
    }
  }, [text, selectedCountry, dispatch, fetchTranslatorData]);

  return (
    <div className="serach-box search-type-1">
      <textarea
        className="textarea textarea-type-1"
        placeholder="Type the Description"
        value={text}
        onChange={onChangeText}
      ></textarea>
      <button
        type="button"
        className="btn-s pri"
        onClick={onClickTranslator}
        disabled={text.trim().length > 0 ? false : true}
      >
        Translate
      </button>
      {/* 자동으로 구글에서 언어 감지를 하기 때문에 언어 선택은 필요 없다 */}
      {/* <label className="select">
        <select onChange={onChangeSelect}>
          {CountryCodeListTwoDigit.map((item, index) => (
            <option key={index} value={item.value}>{`From ${item.text}`}</option>
          ))}
        </select>
      </label> */}
    </div>
  );
};

export default SearchBox;
